// components/RevenueOverTime.tsx
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

const RevenueOverTime = ({ data }: { data: { month: string; billing: number; collection: number }[] }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Line type="monotone" dataKey="billing" stroke="#8884d8" name="Billing" />
        <Line type="monotone" dataKey="collection" stroke="#82ca9d" name="Collection" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RevenueOverTime;
